import { render, staticRenderFns } from "./CreatePOAPopup.vue?vue&type=template&id=e8f80a38"
import script from "./CreatePOAPopup.vue?vue&type=script&lang=js"
export * from "./CreatePOAPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports